import { types } from '../constants';

export const fetchAllCoursesForBranchDispatch = (branchId) => ({
  type: types.FETCH_ALL_COURSES_FOR_BRANCH,
  branchId
});

export const fetchAllCourseRecordssForBranchDispatch = (branchId) => ({
  type: types.FETCH_ALL_COURSE_RECORDS_FOR_BRANCH,
  branchId
});

export const fetchAllCoursesForCompanyDispatch = (companyId) => ({
  type: types.FETCH_ALL_COURSES_FOR_COMPANY,
  companyId
});

export const fetchAllCourseRecordsForCompanyDispatch = (companyId) => ({
  type: types.FETCH_ALL_COURSE_RECORDS_FOR_COMPANY,
  companyId
});

export const searchTermChangeForAllCoursesDispatch = (searchTerm) => ({
  type: types.CHANGE_SEARCH_TERM_ALL_COURSES,
  searchTerm
});

export const openCreateCourseDialogDispatch = (open) => ({
  type: types.OPEN_CREATE_COURSE_DIALOG,
  open
});

export const onHandleInputChange = (value, inputfieldName) => ({
  type: types.INPUT_CHANGE_CREATE_COURSE_FORM,
  value,
  inputfieldName
});

export const handleEditRecordInputChangeDispatch = (value, inputfieldName) => ({
  type: types.INPUT_CHANGE_EDIT_COURSE_RECORD,
  value,
  inputfieldName
});

export const submitCourseDispatch = (course, mode) => ({
  type: types.SUBMIT_COURSE,
  course,
  mode
});

export const openEditCoursePanelDispatch = (open) => ({
  type: types.OPEN_EDIT_COURSE_PANEL,
  open
});

export const openEditCourseDialogDispatch = (open) => ({
  type: types.OPEN_EDIT_COURSE_DIALOG,
  open
});

export const openDeleteCourseDialogDispatch = (open, course) => ({
  type: types.OPEN_DELETE_COURSE_DIALOG,
  open,
  course
});

export const submitDeleteCourseRequestDispatch = (course) => ({
  type: types.DELETE_COURSE,
  course
});

export const courseEditClickDispatch = (course) => ({
  type: types.EDIT_COURSE,
  course
});

export const fetchRecordsForTheCourseDispatch = (courseId) => ({
  type: types.FETCH_RECORDS_FOR_THE_COURSE,
  courseId
});

export const handleDeleteCourseRecordClickDispatch = (payload) => ({
  type: types.DELETE_COURSE_RECORD,
  payload
});

export const enableEditCourseRecord = (enableEditRecordMode, recordId) => ({
  type: types.ENABLE_EDIT_COURSE_RECORD,
  enableEditRecordMode,
  recordId
});

export const submitCourseRecordDispatch = (
  payload,
  mode,
  source,
  branchId
) => ({
  type: types.SUBMIT_COURSE_RECORD,
  payload,
  mode,
  source,
  branchId
});

export const removeCourseRecordAttachment = (attachment) => ({
  type: types.REMOVE_COURSE_RECORD_ATTACHMENT,
  attachment
});

export const fetchExistingAttachmentsForTheCourseRecordDispatch = (
  domainTypeId,
  parentId,
  loggedInUserId
) => ({
  type: types.LOAD_ATTACHMENTS_FOR_COURSE_RECORD,
  domainTypeId,
  parentId,
  loggedInUserId
});

export const removeCourseRecordAttachmentEdit = (attachment) => ({
  type: types.REMOVE_COURSE_RECORD_ATTACHMENT_EDIT,
  attachment
});
